import { decodeToken } from 'react-jwt';
import { useSessionContext } from '../../../session';

type JWTResponseType = {
  token: string,
}

export function useJWTResponse() {
  const { setSessionExpTime } = useSessionContext();

  return (response: JWTResponseType) => {
    const jwtToken = response.token;
    setSessionExpTime(jwtToken);
    return decodeToken(jwtToken);
  };
}
